import { IPeople } from './IPeople';
import { PeopleMapper } from './mapper';

/**
 * iterate through the people result response and crate a model with help of mapper class
 * @param   {array} data search api response
 */
export class PeopleModel {
  peopleData: Array<IPeople> = [];

  constructor(peopleData: any = []) {
    if (peopleData) {
      const transModel = new PeopleMapper(peopleData);
      this.peopleData.push(transModel.peopleUser);
    }
  }
}
